import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../../hooks/useApi';
import { BillingCycleRes } from '../rtm_plan/index.type';

export interface IState{
key:string,
value:string
}

const useAllBillingCycle = () => {
    const [billingCycleOption, setBillingCycleOption] = React.useState<IState[]>([]);

    
    const { loading:billingCycleLoading, makeApiCall } = useApi({
      url: `/rtm/billing-cycle/days`,
      method: 'GET',
    });
  
    const getBillingCycleOption = async () => {
      const { response, error } = await makeApiCall<undefined, BillingCycleRes>();
      
      if (response?.status === 'success') {
      
        setBillingCycleOption(response.data);
        
      }
  
      if (error) toast.error('Something went wrong while billing cycle. Please try again later');
      return [];
    };
  
    return {
      billingCycleOption,
      getBillingCycleOption,
      billingCycleLoading,
    };
  };
  
export default useAllBillingCycle;